module.exports = __webpack_public_path__ + "assets/40a0b6c8b676c806d45072b87ab8866b.png";